function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKvartalnaStatistika(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24.087 24.087",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M10.767,2.555C4.821,2.555,0,7.375,0,13.32c0,5.946,4.821,10.765,10.767,10.765 c5.943,0,10.764-4.819,10.764-10.765H10.767V2.555z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M12.716,0.001c-0.334,0-0.604,0.271-0.604,0.604v10.764c0,0.334,0.27,0.605,0.604,0.605h10.766 c0.333,0,0.605-0.271,0.605-0.605C24.087,5.101,18.985,0.001,12.716,0.001z M13.321,10.766V1.228 c5.121,0.301,9.237,4.416,9.538,9.538H13.321z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKvartalnaStatistika);
export default __webpack_public_path__ + "static/media/KvartalnaStatistika.3ce8c7e61c9f3a7020c6249af72276a3.svg";
export { ForwardRef as ReactComponent };